<template>
  <div class="content-v2">
    <div class="stars-grid-v2">
      <router-link class="star-card-v2" v-for="item in starList" :key="item.id" :to="'/enterprise/stars/' + item.id">
        <div class="star-img-v2">
          <img :src="item.image" :alt="item.title" />
        </div>
        <div class="star-info-v2">
          <h4>{{ item.title }}</h4>
          <p>{{ item.summary }}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getCultureArticleList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultStarImage from '@/assets/images/staff1.svg'

export default {
  name: 'EntStarsV2',
  data() {
    return {
      starList: Array.from({ length: 6 }).map((_, index) => ({
        id: index + 1,
        title: `优秀员工 ${index + 1}`,
        summary: '工程技术部 / 项目经理',
        image: defaultStarImage
      }))
    }
  },
  created() {
    getCultureArticleList({ articleType: 'star', pageNum: 1, pageSize: 30 }).then(({ rows }) => {
      if (!rows || !rows.length) {
        return
      }
      this.starList = rows.map(item => ({
        id: item.articleId,
        title: item.articleTitle,
        summary: item.summary || item.publishDate || '',
        image: resolveFileUrl(item.coverUrl, defaultStarImage)
      }))
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
.stars-grid-v2 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.star-card-v2 {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  transition: all 0.4s;
  color: inherit;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(0,0,0,0.1);
  }

  .star-img-v2 {
    height: 260px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s;
    }

    &:hover img {
      transform: scale(1.05);
    }
  }

  .star-info-v2 {
    padding: 24px;
    text-align: center;

    h4 {
      font-size: 20px;
      font-weight: 600;
      color: #0f172a;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      color: #64748b;
    }
  }
}

@media (max-width: 960px) {
  .stars-grid-v2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .stars-grid-v2 {
    grid-template-columns: 1fr;
  }
}
</style>
